import React, { useEffect, useState } from "react";
import {
  Link,
  useLocation,
  useNavigate,
  useNavigation,
  useParams,
} from "react-router-dom";
import styled from "styled-components";
import { makeStyles } from "@material-ui/core/styles";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { getAuth } from "firebase/auth";
import Drag from "../Components/draganddrop";
import cross from "../Assets/cross.svg";
import DummyImage from "../Assets/product_img.svg";
import upload from "../Assets/drag.svg";
import {
  Box,
  Chip as MuiChip,
  Divider as MuiDivider,
  Grid,
  Paper as MuiPaper,
  Typography,
  IconButton,
  FontAwesomeIcon,
  Paper,
} from "@material-ui/core";
import { spacing } from "@material-ui/system";
import CopyToClipboardButton from "../Components/CopyToClipboardButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import HelpIcon from "@mui/icons-material/Help";
import ActivateUserModal from "../Components/modals/ActivateUserModal";
import ButtonIconComponent from "../Components/ButtonIcons";
import {
  GetSingleData,
} from "../NetworkCalls/Admin/ServerReq";


const Divider = styled(MuiDivider)(spacing);

const EditUser = () => {
  const params = useParams()
  const [data, setData] = useState({});

  const handleOnchange = (e) => {
    const { name, value } = e.target;
    setData((preValue) => {
      return {
        ...preValue,
        [name]: value,
      };
    });
  };

    useEffect(() => {
    const getData = async () => {
      try {
        
        const response = await GetSingleData("Users", params.userid);
        
        setData(response);

        
      } catch (err) {
       
      } finally {
       
      }
    };

    getData();
  }, []);

  // =======

  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <ActivateUserModal
        open={open}
        handleOpen={handleOpen}
        handleClose={handleClose}
      >
        <Box
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "1rem",
            marginBottom: "1rem",
          }}
        >
          <HelpIcon
            style={{
              color: "#ffc107",
              fontSize: "50px",
            }}
          />
          <Typography
            gutterBottom
            variant="h1"
            style={{
              fontWeight: "600",
              fontSize: "30px",
              textAlign: "center",
              margin: "0",
            }}
          >
            Are you sure?
          </Typography>
        </Box>

        <Typography
          style={{
            fontSize: "18px",
            textAlign: "center",
            margin: "0",
          }}
        >
          User account will be Activated!
        </Typography>

        <Box
          
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "1rem",
            margin: "2rem 0 0 auto",
            width:"30%",
            
         
          }}
        >
         <Typography
          style={{
            fontSize: "18px",
            textAlign: "center",
            margin: "0",
            cursor: "pointer"
          }}
          onClick={handleClose}
        >
          Cancel
        </Typography>

          <ButtonIconComponent
            loader={false}
            name="Activate"
            onClick={() => console.log("Template")}
            imageBool={false}
          />
        </Box>
      </ActivateUserModal>

      <Grid
        style={{ marginBottom: "10px" }}
        justify="space-between"
        container
        spacing={24}
      >
        <Grid
          container
          sm={12}
          md={12}
          lg={12}
          xl={12}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h4" gutterBottom display="inline">
            User Profile
          </Typography>

          <IconButton aria-label="Example" onClick={handleOpen}>
            <MoreVertIcon fontSize="large" />
          </IconButton>
        </Grid>
      </Grid>

      <Divider
        my={6}
        style={{
          marginTop: "20px",
          marginBottom: "20px",
          backgroundColor: "#fafafa",
        }}
      />

      <Divider
        my={6}
        style={{
          marginTop: "20px",
          marginBottom: "20px",
          backgroundColor: "#fafafa",
        }}
      />

<Paper
                        style={{
                            boxShadow: "none !important",
                            border: "1px solid rgba(76, 78, 100, 0.25)",
                            borderRadius: "10px",
                            padding:"10px"
                        }}>



      <Grid item xs={12} xl={6} lg={12} md={6}>
        <Grid
          style={{ marginBottom: "10px", marginTop: "35px" }}
          justify="space-around"
          container
          spacing={2}
        >
          <Grid item xs={12} xl={12} lg={12} md={12}>
            <div
              className=""
              style={{
                width: "250px",
                height: "250px",
                border: " 1px solid #00000033",

                borderRadius: "50%",
              }}
            >
              <img
                src={data?.user_photo_link ? data?.user_photo_link : DummyImage}
                style={{
                  marginBottom: "20px",
                  borderRadius: "inherit",
                  width: "100%",
                  height: "100%",
                }}
              />
            </div>
          </Grid>
        </Grid>
      </Grid>

      <div className="dashboard_container">
        <form>
          <Grid
            style={{ marginBottom: "10px", marginTop: "35px" }}
            container
            spacing={2}
          >
            <Grid item xs={12} xl={6} lg={6} md={6}>
              <TextField
                id="outlined-basic"
                type="text"
                name="FullName"
                label="Full Name"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                value={data?.user_fullname ? data?.user_fullname : "null"}
                fullWidth={true}
              />
            </Grid>

            <Grid item xs={12} xl={6} lg={6} md={6}>
              <TextField
                id="outlined-basic"
                type="text"
                name="Gender"
                label="Gender"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                value={data?.user_gender ?  data?.user_gender : "null"}
                fullWidth={true}
              />
            </Grid>

            <Grid item xs={12} xl={6} lg={6} md={6}>
              <Box
                style={{
                  display: "flex",
                }}
              >
                <TextField
                  id="outlined-basic"
                  type="text"
                  name="PhoneNumber"
                  label="Phone Number"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  value={data?.user_phone_number ? data?.user_phone_number  : "null"}
                  fullWidth={true}
                />
                <CopyToClipboardButton text={data?.user_phone_number ? data?.user_phone_number : "null"} />
              </Box>
            </Grid>

            <Grid item xs={12} xl={6} lg={6} md={6}>
              <TextField
                id="outlined-basic"
                type="text"
                name="Email"
                label="Email"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                value={data?.user_email ? data?.user_email : "null"}
                fullWidth={true}
              />
            </Grid>

            <Grid item xs={12} xl={6} lg={6} md={6}>
              <Box
                style={{
                  display: "flex",
                }}
              >
                <TextField
                  id="outlined-basic"
                  type="text"
                  name="User ID"
                  label="User ID"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  value={data?.user_id ? data?.user_id : "null" }
                  fullWidth={true}
                />
                <CopyToClipboardButton text={data?.user_id ? data?.user_id : "null"} />
              </Box>
            </Grid>

            <Grid item xs={12} xl={6} lg={6} md={6}>
              <TextField
                id="outlined-basic"
                type="text"
                name="Role"
                label="Role"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                value={data?.user_role ? data?.user_role :"null"}
                fullWidth={true}
              />
            </Grid>
          </Grid>

          <Box mt={2}>
            <Typography style={{ color: "#E12F2F" }}>{Error}</Typography>
          </Box>
          {/* <button>hdsdsu</button> */}
        </form>
      </div>

      </Paper>
    </React.Fragment>
  );
};

export default EditUser;
